import { AxiosInstance } from "axios";
import { TokenHelper } from "../../types";
import {
  CharitableOrganizationSearchRequest,
  CharitableOrganizationSearchResult,
} from "../../types/charitable-organization";

// All the paths for this api domain.
export const charitableOrganizationPaths = {
  search: (flowId: string) =>
    `/flows/${flowId}/charitable-organizations/search`,
};

class CharitableOrganizationApi {
  api: AxiosInstance;
  tokenHelper: TokenHelper;

  constructor(api: AxiosInstance, tokenHelper: TokenHelper) {
    this.api = api;
    this.tokenHelper = tokenHelper;
  }

  /**
   * Search charitable organizations for the given flow. The flow supplies
   * the org-search configuration server-side (credential environment, etc.)
   * and must belong to the caller's financial institution.
   */
  searchOrganizations = (
    flowId: string,
    request: CharitableOrganizationSearchRequest
  ) => {
    return this.api.post<CharitableOrganizationSearchResult>(
      charitableOrganizationPaths.search(flowId),
      request,
      {
        headers: {
          Authorization: this.tokenHelper.formatAuthHeader(
            this.tokenHelper.getJwtToken()
          ),
        },
      }
    );
  };
}

export default CharitableOrganizationApi;
